import MyAgentsView from "../../components/agents/MyAgentsView";

export function AgentsPage({
  backendGeographies,
  currentUser,
  onAddAgent,
  onAssignLead,
  onBulkAssign,
  onBulkReassign,
  onUploadLeads,
}) {
  return (
    <MyAgentsView
      backendGeographies={backendGeographies}
      currentUser={currentUser}
      onAddAgent={onAddAgent}
      onAssignLead={onAssignLead}
      onBulkAssign={onBulkAssign}
      onBulkReassign={onBulkReassign}
      onUploadLeads={onUploadLeads}
    />
  );
}

export default AgentsPage;
